/**
 * The Study Documents hub cards whose generator refuses to run until at least
 * one case report form is approved ("No approved CRF forms found").
 *
 * ONE LIST for the hub's gating, so the cards cannot disagree: before this, only
 * dataDictionary and editChecks were gated, while the plan, SDTM mapping, EDTS
 * and coding specification cards showed a plain Generate button that the server
 * then refused. drcp, saerp and dblc are deliberately NOT here: their generators
 * do not refuse on zero approved forms.
 *
 * `functions/src/crf/approvedFormPrerequisite.guard.test.ts` reads each server
 * generator and fails if this list stops matching what the server refuses.
 */
export const APPROVED_FORM_PREREQUISITE_DOCS = [
  'dataDictionary',
  'crfInstructionGuide',
  'dataManagementPlan',
  'editChecks',
  'sdtmMapping',
  'edts',
  'medicalCodingSpec',
] as const;

export function needsApprovedForms(cardId: string): boolean {
  return (APPROVED_FORM_PREREQUISITE_DOCS as readonly string[]).includes(cardId);
}

/**
 * The Study Build page documents whose generators refuse the same way: the
 * seven SDLC combined documents and the UAT Protocol. Keys are the row ids in
 * RequirementsDesignCard.tsx and TestingQualificationCard.tsx.
 *
 * The standalone sub-documents (sysreq, sysReqAttrs, dbPhysModel, dbAttrs,
 * ifaceFeatures, ifaceAttrs) and the Test Plan, Test Procedure, Test List and
 * UAT Report do NOT refuse on zero approved forms, so they are not here.
 * `approvedFormPrerequisite.guard.test.ts` checks this list against the server.
 */
export const STUDY_BUILD_APPROVED_FORM_DOCS = [
  'urs',
  'frs',
  'sds',
  'ads',
  'atds',
  'sacs',
  'iis',
  'uat',
] as const;

export function needsApprovedFormsOnStudyBuild(rowId: string): boolean {
  return (STUDY_BUILD_APPROVED_FORM_DOCS as readonly string[]).includes(rowId);
}
